<p-sidebar id="sideBarBtn" [(visible)]="showSearch" [style]="{'margin-top': '125px', 'width': '600px', 'height': [sideBarHeight]}" appendTo="body" [modal]="true" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <label style="font-size: 16px; font-weight: bold; margin-right: 40px;">Search Criteria </label>
        <span *ngIf="!isProd">
            <p-radioButton value="false" [(ngModel)]="showDefaultHeaders" label="Apply saved column width"/>
            <p-radioButton value="true" label="Apply default" [style]="{'margin-left': '5px'}"[(ngModel)]="showDefaultHeaders"/>
        </span>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="grid nested-grid" style="margin-top: 5px; margin-left: -15px;">
            <div class="col-6">
                <div class="grid">
                    <div class="col">
                        <label for="crop">Crop* </label>
                        <p-dropdown id="crop" [options]="crops" [(ngModel)]="selectedCrop" [showClear]="true" (ngModelChange)="changeCrop(false)" [filter]="true" filterMatchMode="startsWith" optionLabel="Name" placeholder="Select" [style]="{'height': '36px'}" />
                    </div>
                    <div class="col">
                        <label for="level">Level* </label>
                        <p-dropdown id="level" data-toggle="tooltip" data-placement="top" title="Select Program, Region or EZ" [options]="levels" [showClear]="true" [(ngModel)]="selectedLevel" (ngModelChange)="changeLevel()" optionLabel="name" placeholder="Select" [style]="{'width':'175px', 'height': '36px'}" />
                    </div>
                </div>
            </div>
            <div class="col" style="margin-left: -10px;">
                <span *ngIf="this.selectedLevel?.name == 'Program(s)'" style="margin-left: 55px;">
                    <p-checkbox data-toggle="tooltip" data-placement="top" title="Filter favorite programs." [(ngModel)]="favProgramsChecked" label="My Favorite Programs" [style]="{'width': '23px','margin-left': '10px','margin-bottom': '3px'}" [binary]="true" (onChange)="toggleFavorites($event)" inputId="binary"  />
                </span>
                <div [style]="this.selectedLevel?.name == 'Program(s)' ? 'margin-top:10px;' : 'margin-top:20px;'"></div>
                <div class="grid" style="margin-left: 0px;align-items: center;">
                    <label for="include">Include*</label>
                    <ng-select [items]="inclusions" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onLevelSearch" placeholder="Select" bindLabel="code" [(ngModel)]="selectedInclusions">
                        <ng-template ng-option-tmp let-item="item">
                            <div data-toggle="tooltip" data-placement="top" title="{{item.desc}}" style="width: 100%;">{{ item.code }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="grid" style="margin-left: -15px;">
            <div class="col-6">
                <label for="stage">Stage</label>
                <ng-select data-toggle="tooltip" data-placement="top" title="Select stage to apply filter on search." [items]="stages" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selectedStages"></ng-select>
            </div>
            <div class="col" style="margin-left: -10px;">
                <label for="years" style="width: 57px;">Year</label>
                <ng-select data-toggle="tooltip" data-placement="top" title="Select year to apply filter on search." [items]="years" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selectedYears">
                </ng-select>
            </div>
        </div>
        <!-- <div class="grid" style="margin-top: 5px; margin-left: -15px;" data-toggle="tooltip" data-placement="top" title="Select Gen to get GEID and Name for nesting levels you want to view.">
            <div class="col-6">
                <label for="genToFetch">Generations To Summarize</label>
            </div>
            <div class="col" style="margin-left: -10px;">
                <p-dropdown id="genToFetch" [options]="genList" [showClear]="true" [(ngModel)]="genToFetch" optionLabel="name" [style]="{'height': '36px'}" />
            </div>
        </div> -->
        <div style="margin-top: 5px;margin-left: -8px;margin-right: -8px;">
            <label style="margin-bottom:3px;width: 268px;">Germplasm Assessments ({{selectedAssessments.length}}/{{geAssessmentsList.length}})</label>
            <span data-toggle="tooltip" data-placement="top" title="Add Germplasm Assessments">
                <p-button id="buttonStyle" size="small" [disabled]="selectedCrop == undefined" (onClick)="addGeAssessments()">Manage</p-button>
            </span>
            <p-table *ngIf="showGeTraitGrid" [value]="geAssessmentsList"  selectionMode="multiple" [(selection)]="selectedAssessments" dataKey="traitId"  [tableStyle]="{ 'margin-top':'5px' }">
                <ng-template pTemplate="header">
                    <tr ngClass="prime-table">
                        <th style="width: 2rem" data-toggle="tooltip" data-placement="top" [title]="sessionName ? 'Disabled for session' : ''"><p-tableHeaderCheckbox [disabled]="sessionName ? true : false" /></th>
                        <th>Assessment Name</th>
                        <th>Source</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr ngClass="prime-table">
                        <td data-toggle="tooltip" data-placement="top" [title]="getToolTip(rowData, 'geTraits')" (click)="onRowClick(rowData, 'geTraits')">
                            <p-tableCheckbox [value]="rowData" />
                        </td>
                        <td>{{ rowData.traitName }}</td>
                        <td>{{ rowData?.source }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div style="margin-top: 5px;margin-left: -8px;margin-right: -8px;">
            <label style="margin-bottom:3px;width: 268px;">PStage/Vote Settings ({{selectedPStages.length}}/{{pStageData.length}})</label>
            <p-button id="buttonStyle" size="small" data-toggle="tooltip" data-placement="top" title="Add PStages" (onClick)="showPStageDialog()">Manage</p-button>
            <p-table *ngIf="showPStageGrid" [value]="pStagesList" selectionMode="multiple" [(selection)]="selectedPStages" dataKey="id" [tableStyle]="{ 'margin-top':'5px' }">
                <ng-template pTemplate="header">
                    <tr ngClass="prime-table">
                        <th style="width: 2rem" data-toggle="tooltip" data-placement="top" [title]="sessionName ? 'Disabled for session' : ''"><p-tableHeaderCheckbox [disabled]="sessionName ? true : false" /></th>
                        <th>Type</th>
                        <th>Level</th>
                        <th>Name</th>
                        <th>Year</th>                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr ngClass="prime-table">
                        <td data-toggle="tooltip" data-placement="top" [title]="getToolTip(rowData, 'pstage')" (click)="onRowClick(rowData, 'pstage')">
                            <p-tableCheckbox [value]="rowData" />
                        </td>
                        <td>{{ rowData.settingType }}</td>
                        <td>{{ rowData.type }}</td>
                        <td>{{ rowData.name }}</td>
                        <td>{{ rowData?.year }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="grid" style="margin-top: 20px; justify-content: right;">
            <span data-toggle="tooltip" data-placement="top" [title]="isAllowAppendSession === null ? 'Please Load a session to append to it' : isAllowAppendSession ? 'Load grid with new data' : 'Add GE Assessmnets or PStage Settings to append to Session.'">
                <p-button id="buttonStyle" size="small" [disabled]="!isAllowAppendSession" (onClick)="SearchData(true)"> Append Session</p-button>
            </span>
            <span data-toggle="tooltip" data-placement="top" [title]="!(selectedCrop && selectedLevel && selectedInclusions && selectedInclusions.length > 0) ? 'Crop, Level and Include are required.' : 'Search Data'">
                <p-button id="buttonStyle" size="small" [disabled]="!(selectedCrop && selectedLevel && selectedInclusions && selectedInclusions.length > 0)" (onClick)="SearchData(false)"> Retrieve</p-button>
            </span>
            <p-button id="buttonStyle" size="small" data-toggle="tooltip" data-placement="top" [disabled]="!allowReset" title="Cancel Changes" (onClick)="resetSearch()"> Reset</p-button>
        </div>
    </ng-template>
</p-sidebar>
<p-sidebar id="sideBarBtn" [(visible)]="showSessions" [style]="{'margin-top': '125px', 'width': '600px', 'height': [sideBarHeight]}" appendTo="body" [modal]="true" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <label style="font-size: 16px; font-weight: bold; margin-right: 40px;">Sessions </label>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="grid" data-toggle="tooltip" data-placement="top" title="Load a previously saved session." style="margin-top: 10px;">
            <label style="width: 200px; margin-top: 2px; margin-right: 60px;">Existing Sessions</label>
            <p-button id="buttonStyle" size="small" [disabled]="sessionGridApi?.getSelectedRows()?.length !== 1" (onClick)="loadSession()"> Load</p-button>
            <p-button id="buttonStyle" size="small" [disabled]="!(sessionGridApi?.getSelectedRows()?.length > 0)" (onClick)="shareSessions()"> Share</p-button>
            <p-button id="buttonStyle" size="small" [disabled]="!(sessionGridApi?.getSelectedRows()?.length > 0)" (onClick)="deleteSessions()"> Delete</p-button>
            <p-button id="buttonStyle" size="small" [disabled]="!allowUpdateSessions" (onClick)="updateSessions()"> Update</p-button>
        </div>
        <div style="height: 90%;">
            <ag-grid-angular *ngIf="sessions.length > 0"
                style="margin-left: -15px; margin-top: 10px; height: 100%;" class="ag-theme-balham" [columnDefs]="sessionColumnDefs" [defaultColDef]="sessionDefaultColDef" 
                [animateRows]="true" [rowData]="sessions" [enableRangeSelection]=true [sideBar]="defToolPanel"
                [suppressRowClickSelection]="true" (gridReady)="onSessionGridReady($event)"                      
                [rowSelection]="'multiple'" [animateRows]="true" (rowSelected)="selSession"></ag-grid-angular>
        </div>
        
    </ng-template>
</p-sidebar>
<div class="grid">
    <div class="col-fixed p-2 border-round-sm" style="width:30px;background-color: lightgray;margin-top: 8px; margin-left: -13px; color: black;" style.height="{{searchHeight}}px">
        <div class="col-fixed p-2 border-round-sm" style="width:30px;margin-left: -8px; cursor: pointer;border: 1px solid black;" (click)="setHeight(); showSearch = true;">
            <i class="pi pi-search"></i>
            <div style="writing-mode: tb-rl;margin-left: -3px; margin-top: 5px; font-size: 18px;">Search Criteria</div>
        </div>
        <div class="col-fixed p-2 border-round-sm" style="width:30px;border: 1px solid black; margin-left: -8px; cursor: pointer;" (click)="setHeight(); showSessions = true;">
            <i class="pi pi-thumbtack"></i>
            <div style="writing-mode: tb-rl;margin-left: -3px; margin-top: 5px; font-size: 18px;">Sessions</div>
        </div>
    </div>
    
    <div *ngIf="rowData.length > 0" class="col" style="margin-left: -7px;">
        <div class="grid">
            <div class="col-fixed" style="margin-left: 1px;">
                <label *ngIf="sessionName" style="margin-right: 10px; font-weight: 800;">{{sessionName}}</label>
                <label style="font-weight: 800; margin-right: 5px;">Expand By :</label>
                <span style="margin-right: 2px;">
                    <p-checkbox [(ngModel)]="geLineageChecked" label="GE Lineage" (onChange)="onExpandOptionChanged($event, 'ge')" [binary]="true" inputId="binary" [style.backgroundColor]="getBGColorByExpandType('GE')" />
                </span>
                <span style="margin-right: 2px;">
                    <p-checkbox [(ngModel)]="seedInventoryChecked" label="Seed Inventory" (onChange)="onExpandOptionChanged($event, 'si')" [binary]="true" inputId="binary" [style.backgroundColor]="getBGColorByExpandType('SI')" />
                </span>
                <span style="margin-right: 2px;">
                    <p-checkbox [(ngModel)]="popRequestChecked" label="Pop Request" (onChange)="onExpandOptionChanged($event, 'pop')" [binary]="true" inputId="binary" [style.backgroundColor]="getBGColorByExpandType('POP')" />
                </span>
                <span style="margin-right: 2px;">
                    <p-checkbox [(ngModel)]="experimentsChecked" label="Experiments" (onChange)="onExpandOptionChanged($event, 'expt')" [binary]="true" inputId="binary" [style.backgroundColor]="getBGColorByExpandType('EXPT')" />
                </span>
                <span style="margin-right: 2px;">
                    <p-checkbox [(ngModel)]="apexVoteChecked" label="APEX Vote" (onChange)="onExpandOptionChanged($event, 'apex')" [binary]="true" inputId="binary" [style.backgroundColor]="getBGColorByExpandType('APEX')" />
                </span>
                <p-button id="legendBtn" data-toggle="tooltip" data-placement="top" title="Show header color legend" (onClick)="overlayVisible=!overlayVisible" icon="pi pi-info-circle" size="small" severity="secondary" [style]="{'margin-top': '6px','margin-bottom': '-6px'}" />
                <p-overlay [(visible)]="overlayVisible" appendTo="body" [responsive]="{ direction: 'top'}" contentStyleClass="w-29rem p-4 bg-surface-0 dark:bg-surface-900 shadow rounded-border">
                    <div class="grid" style="background-color: white; border-radius: 4px; border-style: solid; border-width: 1px; width: 30rem;">
                        <div class="col-7" style="max-height: 40rem; overflow: visible;">
                            <div id="#{{item.type + 'Header'}}" class="grid" style="margin: 10px;" *ngFor="let item of headerLegend">
                                <p-colorPicker class="dynamicColorPicker" [(ngModel)]="item.color" />
                                <label style="margin-left: 4px; max-height: 25px; font-weight: bold; font-size: 16px;">{{item.type}}</label>
                            </div>  
                        </div>
                        <div class="col">
                            <div style="margin-top: 20px; width: 160px;" data-toggle="tooltip" data-placement="top" title="Apply for current session only">
                                <p-button label="Apply for current session" size="small" severity="primary" [disabled]="!allowLegendResetForSession" (onClick)="applyHeaderLegend(false)" />
                            </div>
                            <div style="margin-top: 20px; width: 160px;" data-toggle="tooltip" data-placement="top" title="Apply for current session and save in preference for future">
                                <p-button label="Apply & Save to preference" size="small" [disabled]="!allowLegendReset" severity="primary" (onClick)="applyHeaderLegend(true)"  />
                            </div>
                        </div>                      
                    </div>
                </p-overlay>
            </div>
            <div class="grid col buttonsLayout" style="justify-content: right; margin-top: 4px;">
                <span data-toggle="tooltip" data-placement="top" title="Undo Changes">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="!allowUndo" icon="pi pi-undo" (onClick)="undoGridChanges()" [style]="{'margin-top': '2px'}"></p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Redo Changes">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="!allowRedo" icon="pi pi-undo" (onClick)="redoGridChanges()" [style]="{'margin-top': '2px','transform':'scaleX(-1)'}"></p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Select Rows">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="gridApi && gridApi.getCellRanges() && gridApi.getCellRanges().length === 0" icon="pi pi-check-circle" (onClick)="selectRows(true)" [style]="{'margin-top': '2px'}"></p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Unselect Rows">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="gridApi && gridApi.getCellRanges() && (gridApi.getCellRanges().length === 0 || gridApi.getSelectedRows().length === 0)" icon="pi pi-minus-circle" (onClick)="selectRows(false)" [style]="{'margin-top': '2px'}"></p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Save Grid Preferences">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="rowData.length === 0" (onClick)="saveGridPreferences()" [style]="{'margin-top': '2px'}"> Save Grid Preferences</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Save data for next session">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="rowData.length === 0" (onClick)="savePageState()" [style]="{'margin-top': '2px'}"> Save Session</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Save">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="updatedData.length === 0" (onClick)="saveChanges()" [style]="{'margin-top': '2px'}"> Save</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Expand Next Gen GE(s)">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="!gridApi || gridApi?.getSelectedRows()?.length === 0" (onClick)="expandChildren()" [style]="{'margin-top': '2px'}"> Expand Progeny</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Cancel Changes">
                    <p-button id="buttonStyle" size="small" styleClass="my-custom-button" [disabled]="updatedData.length === 0" (onClick)="cancelGridChanges()" [style]="{'margin-top': '2px'}"> Cancel</p-button>            
                </span>
            </div>
        </div>
        
        <div style="margin-top: -5px; height: 100%;">   
            <ag-grid-angular id="agGrid"
                (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)" (selectionChanged)="onSelectionChanged($event)" (cellKeyDown)="onCellKeyDown($event)"
                style="width: 100%;font-size: 12px;" style.height="{{gridHeight}}" class="ag-theme-balham" (filterChanged)="onFilerChanged($event)"
                [rowData]="rowData" [enableRangeSelection]=true [gridOptions]="gridOptions" [components]="components"
                [rowSelection]="'multiple'" [suppressRowClickSelection]=true [context]="this"></ag-grid-angular>
                <app-custom-status-bar #customStatusBar></app-custom-status-bar>
        </div>    
    </div>
</div>
<p-dialog [(visible)]="showADDialog" [draggable]="false" [baseZIndex]="10000" [modal]="true" [dismissableMask]="false" [style]="{ 'width': '800px','height': '500px' }" appendTo="body">
    <p-header>
        <div class="row">
            <span style="display: block;">Share "{{ sessionToShare }}"</span>
            <label style="color: grey; font-size: 14px; margin-top: -5px;">Multiple users can be searched with comma as delimiter</label>
            <div class="col-7" style="margin-top: -10px;">
                <input type="text" [(ngModel)]="searchMemberString" placeholder="Search by email, display name or user name" pInputText (keyup.enter)="searchFromAd()" 
                [style]= "{'width': '100%', 'height': '31px', 'margin-top' : '3px', 'margin-right': '5px'}">
            </div>
            <div class="col" style="text-align: end; margin-right: 45px; margin-top: -10px;">
                <button type="button" (click)="searchFromAd()" [disabled]="!(searchMemberString)" pButton style="margin-right: 5px;"
                data-toggle="tooltip" data-placement="top" title="Search for users in AD">Search</button>
                <button type="button" (click)="shareWithADUsers()" [disabled]="!(getUserSelectedRows && getUserSelectedRows.length > 0)" pButton
                  data-toggle="tooltip" data-placement="top" title="Share with selected users and close">Share & Close</button>
              </div>
        </div>
    </p-header>
    <div style="margin-top: -10px;" *ngIf="adUserData.length > 0">
        <p-floatLabel>
            <input id="shareDesc" type="text" [(ngModel)]="shareDescription" pInputText [style]= "{'width': '100%', 'height': '31px'}">
            <label for="shareDesc">Add a description to share</label>
        </p-floatLabel>
        
        <div style="margin-top: 5px;">
            <ag-grid-angular
                style="height: 320px;" (gridReady)="onUserGridReady($event)" [sideBar]="defToolPanel" [pivotMode]="false"
                class="ag-theme-balham" [columnDefs]="userColumnDefs" [defaultColDef]="userDefaultColDef" [animateRows]="true" [rowData]="adUserData" 
                [suppressRowClickSelection]="true" [rowSelection]="'multiple'"></ag-grid-angular>
        </div>
    </div>
</p-dialog>
<p-dialog header="Select Program and Year" [modal]="true" [(visible)]="confirmCodeSearch" [style]="{ width: '500px', height:'400px' }" appendTo="body">
    <div style="margin-top: 15px;" class="grid">
        <div style="margin-left: 10px;">
            <label style="font-size: large; margin-right: 10px;" >Program </label>
            <p-dropdown [options]="programsToCode" [(ngModel)]="selectedCodeProgram" [filter]="true" filterMatchMode="startsWith" placeholder="Select" />
        </div>
        <div style="margin-left: 55px;">
            <label style="font-size: large; margin-right: 10px;">Year </label>
            <p-dropdown [options]="yearsToCode" [(ngModel)]="selectedCodeYear" [filter]="true" filterMatchMode="startsWith" placeholder="Select" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button id="codeCancelBtn" data-toggle="tooltip" data-placement="top" (onClick)="cancelNavigateToCode()" title="Cancel"> Cancel</p-button>
        <p-button id="codeBtn" data-toggle="tooltip" data-placement="top" (onClick)="sendToCode()" title="Go To Code Screen"> Go To Code</p-button>
    </ng-template>
</p-dialog>
<p-dialog *ngIf="showGEsToAdvance" [(visible)]="showGEsToAdvance" [draggable]="false" [baseZIndex]="10000" [modal]="true" [dismissableMask]="false" appendTo="body" [style]="{ 'width': '90%','height': '90%' }" [closable]="false">
    <ng-template pTemplate="header">
        <span style="width:100%"> 
            <div  style="display: flex;justify-content: space-between;">
                <div>
                    <label style="margin-top: 10px; font-size: 17px;">Update PStage for Advanced GE(s)</label>
                </div>
                <div class="grid" style="display: flex; justify-content: flex-end; margin-top: 5px; width: 65vw;">
                    <button pButton type="button" style="margin-right: 5px;" (click)="saveAdvGEChanges()" [disabled]="updatedAdvGEData.length === 0">Update</button>
                    <button pButton type="button" style="margin-right: 5px;" (click)="exportAdvGEGrid(false)" [disabled]="advGEsRowData.length === 0">Export</button>
                    <button pButton type="button" (click)="closeAdvGEGrid()">Close</button>
                </div>
            </div>      
        </span>
    </ng-template>
    <ag-grid-angular id="geGrid"
        (gridReady)="onAdvGEGridReady($event)" (cellValueChanged)="onAdvGECellValueChanged($event)"
        style="height: 71vh; font-size: 12px;" class="ag-theme-balham" (filterChanged)="onAdvGEFilerChanged($event)"
        [rowData]="advGEsRowData" [enableRangeSelection]=true [gridOptions]="advGEGridOptions"
        [rowSelection]="'multiple'" [animateRows]="true" [context]="this"></ag-grid-angular>
        <app-custom-status-bar #advGridFilterBar></app-custom-status-bar>
</p-dialog>
<p-dialog [(visible)]="showFindReplace" [draggable]="false" header="Find/Replace" [baseZIndex]="10000" [modal]="false" [dismissableMask]="false" appendTo="body" [position]="'topright'" styleClass="headerPanelSmall">
    <div class="grid" style="margin: 10px; margin-top: 2px;">
        <label style="width: 120px; margin-top: 5px;">Find what</label>
        <input type="text" pInputText [(ngModel)]="findText" style="margin-left: 5px; margin-right: 25px;" />
        <span data-toggle="tooltip" data-placement="top" title="Find Next">
            <p-button id="buttonStyle" [disabled]="!findText" (onClick)="find(true)" [style]="{width: '97px', padding: '7px', 'padding-left': '12px'}"> Find Next</p-button>
        </span>
    </div>
    <div class="grid" style="margin: 10px;">
        <label style="width: 120px; margin-top: 5px;">Replace With</label>
        <input type="text" pInputText [(ngModel)]="replaceText" style="margin-left: 5px; margin-right: 25px;"/>
        <span data-toggle="tooltip" data-placement="top" title="Replace next match">
            <p-button id="buttonStyle" [disabled]="!findText" (onClick)="replace(false)" [style]="{width: '97px', padding: '7px', 'padding-left': '15px'}"> Replace</p-button>
        </span>
    </div>
    <div class="grid" style="margin: 10px;">
        <div style="margin-top: 5px;">
            <p-checkbox [(ngModel)]="matchCaseChecked" label="Match case" (onChange)="foundCell=[]" [binary]="true" inputId="binary" />
        </div>
        <div style="margin-left: 50px; margin-right: 60px; margin-top: 5px; margin-bottom: 2px;">
            <p-checkbox [(ngModel)]="matchWordChecked" label="Match Word" (onChange)="foundCell=[]" [binary]="true" inputId="binary" />
        </div>
        <span data-toggle="tooltip" data-placement="top" title="Replace All">
            <p-button id="buttonStyle" [disabled]="!findText" (onClick)="replace(true)" [style]="{padding: '7px'}"> Replace All</p-button>
        </span>
    </div>
</p-dialog>
<p-dialog [(visible)]="showColorSelector" [draggable]="true" header="Select Color" [baseZIndex]="10000" [modal]="true" [dismissableMask]="false" appendTo="body" [position]="'center'" styleClass="headerPanelSmall">
    <div class="grid" style="margin: 10px;">
        <div>
            <label style="margin-bottom: 3px; display: block; width: 150px;">Select From Existing Grid Color(s)</label>
            <select id="lbMainColor" name="Colors" size="5" style="width: 150px;" (change)="updateColor($event)"></select>
        </div>
        <div style="margin-left: 50px; margin-top: 5px;">
            <div class="grid" style="margin-bottom: 5px;">
                <label style="margin-left: 10px; display: block; margin-right: 30px; margin-top: 2px">Choose Color</label>
                <p-button id="buttonStyle" (onClick)="updateColor(false)">Ok</p-button>
            </div>
            <p-colorPicker [(ngModel)]="selColor" [inline]="true"></p-colorPicker>
        </div>
    </div>
</p-dialog>
<p-dialog *ngIf="showBulkEditDialog" [(visible)]="showBulkEditDialog" [modal]="true" [contentStyle]="{'overflow':'visible'}" [draggable]="false" [baseZIndex]="10000" [dismissableMask]="false" [style]="{ 'width': '800px','height': '475px' }" appendTo="body">
    <p-header class="grid" style="width: 730px; margin-left: 5px;">
        <label style="margin-top: 10px; font-size: larger;">Edit Multiple Rows</label>
        <button pButton type="button" (click)="saveBulkEdit()" style="margin-left: 65%; margin-top: 5px;" [disabled]="!((editPStageChecked && bulkYear) || editCommentsChecked || editMetadataChecked || editCusMetadataChecked)">Apply</button>
    </p-header>
    <div style="color: darkgray; margin-top: -10px; font-size: 15px;">*Add/Update values for muitple rows. To delete existing data, check the corresponding change checkbox and keep the value blank for that field.</div>
    <div style="padding-left: 20px;">
        <div class="grid" style="margin-top: 20px;">
            <label style="width: 230px;">Select Program to udpate</label>
            <ng-select [items]="bulkEditPrgs" [closeOnSelect]="true" [clearable]="false" [markFirst]="true" [(ngModel)]="selBulkEditPrg">
            </ng-select>
        </div>
        <div class="grid" style="margin-top: 20px;">
            <label style="width: 230px;">Append or Overwrite</label>
            <p-checkbox [(ngModel)]="appendComments" label="Append Comments" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
            title="Append or Replace Comments" />
            <p-checkbox [(ngModel)]="appendMetadata" label="Append Metadata" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
            title="Append or Replace Metadata" [style]="{'margin-left': '10px'}" />
            <p-checkbox [(ngModel)]="appendTags" label="Append Tags" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top"
            title="Append or Replace Tags" [style]="{'margin-left': '10px'}" />
        </div>
        <div class="grid" style="margin-top: 20px;">
            <p-checkbox [(ngModel)]="editPStageChecked" [binary]="true" inputId="editPStages" [style]="{'margin-bottom': '10px','margin-right': '10px'}"/>
            <label for="editPStages" style="width: 200px;">Change PStages</label>
            <ng-select [items]="bulkYears" [closeOnSelect]=true [markFirst]="true" placeholder="Select Year" [(ngModel)]="bulkYear" style="width: 160px; margin-right: 10px;">
            </ng-select>
            <ng-select [items]="stages" [closeOnSelect]=true [markFirst]="true" placeholder="Select PStage" [(ngModel)]="bulkPStage" style="width: 330px;">
            </ng-select>
        </div>
        <div class="grid" style="margin-top: 20px;">
            <p-checkbox [(ngModel)]="editCommentsChecked" [binary]="true" inputId="editComments" [style]="{'margin-bottom': '10px','margin-right': '10px'}"/>
            <label for="editComments" style="width: 200px;">Change Comments</label>
            <input type="text" style="width: 500px;" pInputText [(ngModel)]="bulkComments" />
        </div>
        <div class="grid" style="margin-top: 20px;">
            <p-checkbox [(ngModel)]="editMetadataChecked" [binary]="true" inputId="editMetadata" [style]="{'margin-bottom': '10px','margin-right': '10px'}"/>
            <label for="editMetadata" style="width: 200px;">Change MetaData</label>
            <ng-select [items]="metaDataList" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="bulkMetaData" style="width: 500px;">
            </ng-select>
        </div>
        <div class="grid" style="margin-top: 20px;">
            <p-checkbox [(ngModel)]="editCusMetadataChecked" [binary]="true" inputId="editCusMetadata" [style]="{'margin-bottom': '10px','margin-right': '10px'}"/>
            <label for="editCusMetadata" style="width: 200px;">Change Tags</label>
            <ng-select [items]="tagList" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="bulkTags" style="width: 500px;">
            </ng-select>
        </div>  
    </div>
</p-dialog>
<p-dialog [(visible)]="showSaveModal" [modal]="true" [contentStyle]="{'overflow':'visible'}" [draggable]="false" [baseZIndex]="10000" [dismissableMask]="true" [style]="{  'width': '500px','height': '400px' }" styleClass="headerPanelMedium">
    <ng-template pTemplate="header">
        <span style="width:100%"> 
            <div style="display: flex;justify-content: space-between;">
                <label style="margin-top: 7px;">Save Session</label>
                <button pButton type="button" (click)="saveSession()" [disabled]="!sessionName">Save</button>
            </div>
        </span>
        </ng-template>
    <div>
        <p-radioButton value="SaveNewSession" label="Create New Session" [(ngModel)]="sessionType"/>
        <p-radioButton value="UpdateSession" label="Update Session" [style]="{'margin-left': '5px'}" [(ngModel)]="sessionType"/>
        <div *ngIf="sessionType === 'UpdateSession'">
            <label style="margin-top: 20px; margin-bottom: 10px;">
                Select a session to update:
            </label>
            <p-listbox [options]="sessionNames" [style]="{'width': '400px'}" [(ngModel)]="sessionName" [listStyle]="{'max-height': '225px'}" />
        </div>
        <div *ngIf="sessionType === 'SaveNewSession'">            
            <div class="grid" style="margin-top: 10px;">
                <label style="width: 90px;">Name: </label>
                <input style="width: 380px" pInputText type="text" placeholder="Enter a unique Session name" [(ngModel)]="sessionName"/>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="width: 90px;">Description: </label>
                <input style="width: 380px;" pInputText type="text" placeholder="Provide Session description" [(ngModel)]="sessionDesc"/>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="margin-right: 10px;">Existing Sessions: </label>
                <p-listbox [options]="sessionNames" [style]="{'width': '320px'}" [(ngModel)]="sessionName" [readonly]="true" [listStyle]="{'max-height': '180px'}" />
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog  [modal]="true" [(visible)]="showPStageModal" [closable]="false" [draggable]="false" [baseZIndex]="10000" [style]="{  'width': '65%','height': '70vh' }" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex;justify-content: space-between; width: 100%;">
            <h6 style="margin: 0;">Select and Apply PStage/Vote</h6>
            <div>                
                <p-button  id="buttonStyle" data-toggle="tooltip" data-placement="top" (onClick)="addPStageRow()" title="Add Row"> Add Row</p-button>
                <span data-toggle="tooltip" data-placement="top" title="Remove Row">
                    <p-button  id="buttonStyle" [disabled]="!(pStageData.length > 0)" (onClick)="deletePStageRow()"> Remove Row</p-button>
                </span>
                <span data-toggle="tooltip" data-placement="top" title="Add and Close">
                    <p-button  id="buttonStyle" [disabled]="allowPStageSettingSave" (onClick)="savePStageData(true)"> Update </p-button>
                </span>
                <p-button  id="buttonStyle" data-toggle="tooltip" data-placement="top" (onClick)="savePStageData(false)" title="Close"> Close </p-button>
            </div>
        </div>
    </ng-template>
    <div style="display: flex;justify-content: flex-end;">
    </div>
    <div>
        <ag-grid-angular *ngIf="pStageData.length > 0"
        style="height: 55vh;margin-left: 45px;;margin-top: 5px; width: 90%;" 
        class="ag-theme-balham"
        [rowData]="pStageData" 
        [columnDefs]="pStageColDef"
        [defaultColDef]="defaultPStageColDef" 
        [components]="components"
        rowSelection="multiple"
        [stopEditingWhenCellsLoseFocus]="true"
        [enableBrowserTooltips]="true"
        [gridOptions]="gridOptionsPStage"
        (gridReady)="onPStageGridReady($event)"></ag-grid-angular>
    </div>
</p-dialog>
<p-dialog [modal]="true" *ngIf="showAPEXJobs" [(visible)]="showAPEXJobs" [draggable]="false" [baseZIndex]="10000" [style]="{  'width': '1260px','height': '70vh' }" appendTo="body">
    <ng-template pTemplate="header">
        <div class="col-6">
            <h6 style="margin: 0;">Select APEX Session</h6>
        </div>
        <div class="col-2" style="padding-left: 60px;">
            <p-checkbox id="aepxChk" [(ngModel)]="showMyAPEXJobs" label="My Sessions" [binary]="true" (onChange)="onMyJobsChecked($event)" inputId="binary" />
        </div>
        <div>          
            <label>Program*</label>
            <p-dropdown id="apexProg" [options]="programs" [style]="{'margin-left': '5px', 'height': '35px'}" [(ngModel)]="selProgram" [filter]="true" optionLabel="code" placeholder="Select" filterMatchMode="startsWith" />
            <p-button data-toggle="tooltip" data-placement="top" [style]="{'margin-left': '20px'}" [disabled]="!apexGridApi || apexGridApi?.getSelectedRows()?.length === 0" (onClick)="submitAPEXData()" title="Submit GE(s) to APEX">Submit</p-button>
        </div>
    </ng-template>
    <ag-grid-angular *ngIf="apexData.length > 0"
        style="height: 100%;" 
        class="ag-theme-balham"
        [rowData]="apexData" 
        [columnDefs]="apexColDef"
        [defaultColDef]="defaultPStageColDef" 
        rowSelection="single"
        [statusBar]="apexStatusBar"
        (gridReady)="onApexGridReady($event)">
    </ag-grid-angular>
</p-dialog>
<p-dialog [modal]="true" *ngIf="showNurserySelection" [(visible)]="showNurserySelection" [draggable]="false" [baseZIndex]="10000" [style]="{ 'width': '750px','height': '600px' }" appendTo="body">
    <ng-template pTemplate="header">
        <div class="col-6">
            <h6 style="margin: 0;">Select Nursery Info</h6>
        </div>
        <div class="col">
            <p-checkbox [(ngModel)]="selGEsOnly" label="Limit to selected GEs" [style]="{'width': '23px','margin-left': '10px','margin-bottom': '7px','margin-top': '7px'}" [binary]="true" inputId="binary"  />
            <span data-toggle="tooltip" data-placement="top" title="Get Nursery Details">
                <p-button [style]="{'margin-left': '20px'}" [disabled]="selectedExpts.length === 0 && !selGEsOnly" (onClick)="displayReport('nursery')">Submit</p-button>
            </span>
        </div>
    </ng-template>
    <div class="grid">
        <div class="col-8">
            <label>Select Experiments*</label>
            <p-table #exptRef  [value]="assocExpts" selectionMode="multiple" [(selection)]="selectedExpts" dataKey="exptId" [scrollable]="true" scrollHeight="455px">
                <ng-template pTemplate="header">
                    <tr ngClass="prime-table">
                        <th style="width: 2rem"><p-tableHeaderCheckbox /></th>
                        <th>Name</th>
                        <th style="width: 100px;">Year</th>
                        <th style="width: 100px;">Season</th>
                    </tr>
                    <tr ngClass="prime-table">
                        <th style="width: 2rem"></th>
                        <th>
                            <input placeholder="Search" style="width: 90%;font-size: 14px;" pInputText type="text" (input)="exptRef.filter($any($event.target).value, 'exptName' , 'contains')">
                        </th>
                        <th>
                            <input placeholder="Search" style="width: 90%;font-size: 14px;" pInputText type="text" (input)="exptRef.filter($any($event.target).value, 'year' , 'contains')">
                        </th>
                        <th>
                            <input placeholder="Search" style="width: 90%;font-size: 14px;" pInputText type="text" (input)="exptRef.filter($any($event.target).value, 'season' , 'contains')">
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr ngClass="prime-table">
                        <td (click)="onRowClick(rowData, 'nursery')">
                            <p-tableCheckbox [value]="rowData" />
                        </td>
                        <td>{{ rowData.exptName }}</td>
                        <td>{{ rowData.year }}</td>
                        <td>{{ rowData?.season }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="col">
            <label>Select Program </label>
            <p-listbox [options]="programs" [(ngModel)]="selectedPrg" optionLabel="code" [filter]="true" filterMatchMode="startsWith" [listStyle]="{'max-height': '400px'}" />
        </div>
    </div>
</p-dialog>
<p-dialog [modal]="true" *ngIf="showHistoryDialog" [(visible)]="showHistoryDialog" [draggable]="false" [baseZIndex]="10000" [style]="{  'width': '1260px','height': '70vh' }" appendTo="body">
    <ng-template pTemplate="header">
        <div class="col-6">
            <h6 style="margin: 0;">History</h6>
        </div>      
    </ng-template>
    <ag-grid-angular *ngIf="historyData.length > 0"
        style="height: 100%;" 
        class="ag-theme-balham"
        [rowData]="historyData" 
        [columnDefs]="historyColDef"
        [defaultColDef]="defaultPStageColDef" 
        rowSelection="single">
    </ag-grid-angular>
</p-dialog>
<p-dialog [(visible)]="showCopyModal" [modal]="true" [contentStyle]="{'overflow':'visible'}" [draggable]="false" [baseZIndex]="10000" [dismissableMask]="true" [style]="{  'width': '500px','height': '400px' }" styleClass="headerPanelMedium">
    <ng-template pTemplate="header">
        <span style="width:100%">
            <div style="display: flex;justify-content: space-between;">
                <label style="margin-top: 7px; font-weight: bold;">Action: </label>
                <p-radioButton value="copy" label="Copy Rows" [(ngModel)]="copyType"/>
                <p-radioButton value="move" label="Move Rows" [style]="{'margin-left': '5px'}" [(ngModel)]="copyType"/>
                <button pButton type="button" (click)="saveSession()" [disabled]="!sessionCopyName">Save</button>
            </div>
        </span>
        </ng-template>
    <div style="margin-top: -8px;">
        <label style="margin-left: -8px; margin-right: 38px;">Add to: </label>
        <p-radioButton value="SaveNewSession" label="New Session" [(ngModel)]="sessionType"/>
        <p-radioButton value="UpdateSession" label="Existing Session" [style]="{'margin-left': '25px'}" [(ngModel)]="sessionType"/>
        <div *ngIf="sessionType === 'UpdateSession'">
            <label style="margin-top: 20px; margin-bottom: 10px;">
                Select a session to update:
            </label>
            <p-listbox [options]="sessionNames" [style]="{'width': '400px'}" [(ngModel)]="sessionCopyName" [listStyle]="{'max-height': '225px'}" />
        </div>
        <div *ngIf="sessionType === 'SaveNewSession'">            
            <div class="grid" style="margin-top: 10px;">
                <label style="width: 90px;">Name: </label>
                <input style="width: 380px" pInputText type="text" placeholder="Enter a unique Session name" [(ngModel)]="sessionCopyName"/>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="width: 90px;">Description: </label>
                <input style="width: 380px;" pInputText type="text" placeholder="Provide Session description" [(ngModel)]="sessionDesc"/>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="margin-right: 10px;">Existing Sessions: </label>
                <p-listbox [options]="sessionNames" [style]="{'width': '320px'}" [(ngModel)]="sessionCopyName" [readonly]="true" [listStyle]="{'max-height': '180px'}" />
            </div>
        </div>
    </div>
</p-dialog>
<!-- <p-dialog [modal]="true" *ngIf="showUsageModal" [(visible)]="showUsageModal" [draggable]="false" [baseZIndex]="10000" [style]="{  'width': '500px','height': '300px' }">
    <ng-template pTemplate="header">
        <div style="display: flex;justify-content: space-between; width: 100%;">
            <h6 style="margin: 0;">Usage Report Selection</h6>
            <div data-toggle="tooltip" data-placement="top" title="Open Usage Report">                
                <p-button id="usageBtn" (onClick)="displayReport('usage')" [disabled]="selUsageYears.length === 0 || selUsagePrograms.length === 0"> Open Report</p-button>
            </div>
        </div>
    </ng-template>
    <div style="margin-top: 15px;">
        <div class="grid" style="margin-left: 5px;">
            <label style="width: 70px;">Year*</label>
            <ng-select data-toggle="tooltip" data-placement="top" title="Select years." [items]="bulkYears" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selUsageYears" appendTo="body" style="width: 80%;">
            </ng-select>
        </div>
        <div class="grid" style="margin-top: 15px;margin-left: 5px;">
            <label style="width: 70px;">Program*</label>
            <ng-select data-toggle="tooltip" data-placement="top" title="Select programs." [items]="bulkEditPrgs" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selUsagePrograms" appendTo="body" style="width: 80%;">
            </ng-select>
        </div>
        <div class="grid" style="margin-top: 15px;margin-left: 5px;">
            <label style="width: 70px;">Stage</label>
            <ng-select data-toggle="tooltip" data-placement="top" title="Select stages." [items]="stages" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selUsageStages" appendTo="body" style="width: 80%;"></ng-select>
        </div>
    </div>
</p-dialog> -->
<p-dialog [modal]="true" *ngIf="addGEModal" [(visible)]="addGEModal" [draggable]="false" [baseZIndex]="10000" [style]="{ 'width': '350px','height': '450px' }" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex;justify-content: space-between; width: 100%;">
            <h6 style="margin-top: 5px;">Add New Row(s)</h6>
            <div>                
                <p-button id="addRowsBtn" data-toggle="tooltip" data-placement="top" (onClick)="AppendNewRows()" [disabled]="idList.length === 0" title="Add New Row(S)"> Add</p-button>
            </div>
        </div>
    </ng-template>
    <div style="display: block;">
        <label style="font-weight: bold;font-size: large;vertical-align: middle;"> Enter </label>
        <span>
            <p-radioButton value="CVN" [(ngModel)]="searchBy" label="GE_Name" (onClick)="setSearch($event)" />
            <p-radioButton value="GE ID" label="GEID" [style]="{'margin-left': '5px'}" [(ngModel)]="searchBy" (onClick)="setSearch($event)" />
        </span>
        <label style="font-weight: bold; display: block; margin-bottom: 12px;margin-top: 5px;">Total Rows :
            {{idList.length}}</label>
        <span>
            <textarea style="max-height: 270px;" [rows]="30" [cols]="35" [autoResize]="true" [(ngModel)]="idListText" pInputTextarea></textarea>
        </span>
    </div> 
</p-dialog>
<p-confirmDialog [style]="{'width' : '550px', 'height' : '230px'}" [closable]="false" appendTo="body">  
</p-confirmDialog> 
